import React, { Component } from "react";
import { OperatorDataModel, UserTypeRelation } from "../../models/User";
import Loader from "../../components/Loader";
import { toastService } from "../../services/toastService";
import { utils } from "../../utils/utils";
import _ from "lodash";
import { operatorsApiService } from "../../services/api/users/OperatorApiService";
import { RoleModel } from "../../models/Role";
import ProfileShared from "./ProfileShared";
import { rolesApiService } from "../../services/api/users/RolesApiService";

interface ProfileState {
    userId: number | null;
    roles: RoleModel[];
    user: OperatorDataModel | null;
    isLoading: boolean;
}

export default class UpdateOperator extends Component<unknown, ProfileState> {
    constructor(props: unknown) {
        super(props);

        const userId = utils.getIdentifierFromPath();
        this.state = {
            userId: isNaN(userId) ? null : userId,
            roles: [],
            user: null,
            isLoading: true,
        };
    }

    async componentDidMount() {
        if (this.state.userId == null) {
            return;
        }

        this.setState({ isLoading: true });

        const userProfile = await operatorsApiService.getById(this.state.userId);

        if (!userProfile.success) {
            this.setState({ isLoading: false });
            toastService.error(userProfile.message);
            return;
        }

        const roleResult = await rolesApiService.getAllByMerchant(parseInt(userProfile!.data.merchantId!));

        if (!roleResult.success) {
            this.setState({ isLoading: false });
            toastService.error(roleResult.message);
            return;
        }

        this.setState({ isLoading: false, user: userProfile.data, roles: roleResult.data });
    }

    onSubmitButtonClick = async () => {
        this.setState({ isLoading: true });

        const newData = _.cloneDeep(this.state.user);

        const result = await operatorsApiService.update(newData!);

        if (!result.success) {
            this.setState({ isLoading: false });
            toastService.error(result.message);
            return;
        }

        toastService.success("Operation completed successfully.");
        // TNPDEVAPPS-1812: reload so the profile re-fetches the operator and every surface (roles table,
        // dropdown, cross-merchant checkbox) reflects the just-saved state — the read-only roles table is
        // populated on mount, so an in-place setState would leave it stale.
        window.location.reload();
    };

    render() {
        if (this.state.isLoading || this.state.user === null) {
            return (
                <>
                    <Loader />
                </>
            );
        }

        return (
            <>
                <ProfileShared
                    allowResetPhoneAndMobile={false}
                    isEditMode={true}
                    showMerchant={false}
                    showPassword={false}
                    showRoles={true}
                    showCrossMerchantOption={true}
                    merchants={[]}
                    roles={this.state.roles}
                    user={this.state.user}
                    onUpdate={(user) => this.setState({ user: user })}
                    onSubmit={this.onSubmitButtonClick}
                    userType={UserTypeRelation.Operator}
                />
            </>
        );
    }
}
